import { validatePhoneNumberLength } from 'libphonenumber-js';
import { criteriaMet, passwordCriteria } from '../components/Input/PasswordCriteria';
import { isHtml5EmailValid, sanitizeEmailInput } from './emailValidation';

const checked = (value) => ({
  valid: !!value,
  message: 'Must be checked',
  disableForm: true,
});

const isEmpty = (value) => ({
  valid: value?.trim()?.length > 0,
  message: 'Cannot be empty',
  disableForm: true,
});

const validEmail = (value) => {
  const sanitizedValue = sanitizeEmailInput(value);
  return {
    valid: isHtml5EmailValid(sanitizedValue),
    message: 'Please enter a valid email',
    disableForm: true,
  };
};

const validPhone = (value, formValues = {}) => {
  const phoneDigits = (value || '').replace(/\D/g, '');
  const countryCode = formValues.country_code;
  let isTooLong = false;
  if (phoneDigits && countryCode) {
    isTooLong = validatePhoneNumberLength(`+${countryCode}${phoneDigits}`) === 'TOO_LONG';
  }

  return {
    valid: !!phoneDigits && !isTooLong,
    message: 'Please enter a valid mobile number',
    disableForm: true,
  };
};

const validPassword = (value) => ({
  valid: value && criteriaMet(passwordCriteria, value),
  message: 'Please enter a valid password',
  disableForm: true,
});

const formValidations = {
  signup_form: {
    terms_of_service: checked,
    first_name: isEmpty,
    last_name: isEmpty,
    email: validEmail,
    phone: validPhone,
    password: validPassword,
  },
};

const validator = (formName, data, requiredFields) => {
  const validations = formValidations[formName];
  const results = {};
  let isValid = true;
  if (validations && requiredFields) {
    requiredFields.forEach((key) => {
      // Most validation functions take only a single argument,
      // the value of the field that they are checking.
      //
      // Optionally (used in only one place right now), the validation
      // function can also take a second argument, the entire form data,
      // useful for any cases where there is a cross-field dependency.
      results[key] = validations[key](data[key], data);
      if (isValid && results[key].disableForm && !results[key].valid) {
        isValid = false;
      }
    });
  }
  return { isValid, results };
};

export default validator;
